<template>
  <component :is="layoutComponent" />
</template>

<script>
import UserLayout from '@/components/layouts/user/UserLayout';
import AdminLayout from '@/components/layouts/admin/AdminLayout';
import RecruiterLayout from '@/components/layouts/recruiter/RecruiterLayout';
import PrePaywallLayout from '@/components/layouts/pre-paywall/PrePaywallLayout';
import { ROUTES } from '@/router';
import {GUEST_USER_ROLES} from '@/store';

export default {
  name: 'MainLayout',
  components: {
    UserLayout,
    AdminLayout,
    RecruiterLayout,
    PrePaywallLayout,
  },
  computed: {
    layoutComponent: function () {
      if (
          this.$store.getters.userIsMSSUser ||
          this.$store.getters.userIsNonMSSUser
        ) {
          return UserLayout.name;
        }
        if (this.$store.getters.userIsAdmin) {
          return AdminLayout.name;
        }
        if (this.$store.getters.userIsMSSRecruiter) {
          return RecruiterLayout.name;
        }
        if (this.$route.path.indexOf('/recruiter') === 0 || this.$route.path.indexOf('/welcome/recruiter') === 0) {
          this.$store.state.guestCurrentRole = GUEST_USER_ROLES.ROLE_RECRUITER;
          return PrePaywallLayout.name;
        }
        if (this.$route.path.indexOf('/welcome') === 0) {
          this.$store.state.guestCurrentRole = GUEST_USER_ROLES.ROLE_PHYSICIAN;
          return PrePaywallLayout.name;
        }
        if (this.$route.path.indexOf(ROUTES.GUEST_SWITCH_ROLES_PAGE) === 0) {
          return false;
        }
        return UserLayout.name;
    },
  },
};
</script>

<style scoped></style>
